import {chunkArray} from "./chunkArray";

export function aboutSection() {
    let
        slider = $(".about-mobile-slider"),
        list = $(".about-right .dotted-list li"),
        array = chunkArray(list, 6);

    $.each(array, function () {
        let
            slideritem = $("<div/>", {
                class: "about-mobile-item"
            }),
            ul = $("<ul/>");

        $.each($(this), function () {
            ul.append(`<li>${$(this).html()}</li>`);
        });

        slideritem.append(ul);
        slider.append(slideritem);
    });

    slider.slick({
        infinite: false,
        fade: true,
        arrows: false,
        dots: true,
        adaptiveHeight: true,
        slidesToShow: 1
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/aboutSection.js